import { createContext, PropsWithChildren, RefObject } from 'react';

const diagramElementContext = {
   SVGWrapperRef: { current: null } as RefObject<HTMLDivElement | null>,
   SVGRef: { current: null } as RefObject<SVGSVGElement | null>,
};

export const DiagramElementContext = createContext(diagramElementContext);

export function DiagramElementProvider({
   SVGWrapperRef,
   SVGRef,
   children,
}: PropsWithChildren<{
   SVGWrapperRef: RefObject<HTMLDivElement | null>;
   SVGRef: RefObject<SVGSVGElement | null>;
}>) {
   const diagramElementContext = {
      SVGWrapperRef,
      SVGRef,
   };

   return (
      <DiagramElementContext.Provider value={diagramElementContext}>
         {children}
      </DiagramElementContext.Provider>
   );
}
